import { takeEvery, put, select } from 'redux-saga/effects';

import { deletePage } from '../../actions';

import { getType } from 'typesafe-actions';
import { confirmPagesHistoryDeletePage } from './actions';
import { makeGetPagesHistoryExistingPage } from '../../selectors';
import { trackEvent } from '../../../../utils/Analytics';

function* deletePageConfirmationWatcher(action: ReturnType<typeof confirmPagesHistoryDeletePage>) {
  const dateId = action.payload;
  const page = yield select(makeGetPagesHistoryExistingPage(dateId));

  trackEvent('Page_deleted', {});

  yield put(deletePage(page));
}

export function* pagesHistoryPageDetailsSaga() {
  yield takeEvery([getType(confirmPagesHistoryDeletePage)], deletePageConfirmationWatcher);
}



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/PageDetails/saga.ts